import {TextHelper} from "./text.helper";

export const MetaHelper = {
    home(lang) {
        lang = (lang ? lang : 'en').toLowerCase();
        const meta = {
            fr: 'Découvrez l’hôtel 100% digital et sans contact. Pas de réception physique mais des codes reçus par mail, une conciergerie digitale et des Suites d’exception. ',
            en: 'Discover the 100% digital and contactless hotel. No physical reception, just door codes sent by email. Incredible Suites with a digital concierge.'
        }
        return {
            title: 'MiHotel - Lyon',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: meta[lang] === undefined ? meta.fr : meta[lang]
            }]
        }
    },
    extras (lang) {
        lang = (lang ? lang : 'en').toLowerCase();
        const title = {
            fr: 'Nos extras - MiHotel',
            en: 'Our extras - MiHotel'
        };
        const meta = {
            fr: 'Agrémentez votre séjour avec plus de 30 extras à la carte ! Décoration, restauration, massage, presque tout est possible grâce à notre conciergerie digitale.',
            en: 'Choose from over 30 different extras to make your stay unique. Decorations, food, massages: almost anything is possible with our digital concierge.'
        };
        return {
            title: title[lang] === undefined ? title.fr : title[lang],
            meta: [{
                vmid: 'description',
                name: 'description',
                content: meta[lang] === undefined ? meta.fr : meta[lang]
            }]
        }
    },
    room (name, description) {
        return {
            title: name + ' - MiHotel',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: TextHelper.htmlDecode(TextHelper.removeHtml(description))
            }]
        }
    },
    concept (concepts) {
        if (concepts.length === 0)
            return MetaHelper.home('fr')
        return {
            title: concepts.text.meta.title,
            meta: [{
                vmid: 'description',
                name: 'description',
                content: concepts.text.meta.description
            }]
        }
    },
    gdpr (lang) {
        lang = (lang ? lang : 'en').toLowerCase();
        const title = {
            fr: 'Espace RGPD - MiHotel',
            en: 'GDPR area - MiHotel'
        };
        const meta = {
            fr: 'MiHotel porte une attention toute particulière à la protection des données personnelles de ses clients. Découvrez ici la politique de protection des données personnelles (RGDP) de MiHotel.',
            en: 'MiHotel pays a special attention to the protection of customers\' personal data. Find out more about MiHotel\'s privacy policy here. '
        };
        return {
            title: title[lang] === undefined ? title.fr : title[lang],
            meta: [{
                vmid: 'description',
                name: 'description',
                content: meta[lang] === undefined ? meta.fr : meta[lang]
            }]
        }
    },
    invest(lang) {
        lang = (lang ? lang : 'en').toLowerCase();
        const title = {
            fr: 'Investir dans MiHotel',
            en: 'Invest in MiHotel'
        };
        const meta = {
            fr: 'Vous souhaitez faire un investissement dans un immobilier dynamique et haut de gamme pour valoriser votre patrimoine ? Découvrez nos différentes formules pour un investissement gagnant.',
            en: 'You would like to invest in a dynamic and high-end real estate to diversify your assets? Discover our different formulas for a win-win investment.'
        };
        return {
            title: title[lang] === undefined ? title.fr : title[lang],
            meta: [{
                vmid: 'description',
                name: 'description',
                content: meta[lang] === undefined ? meta.fr : meta[lang]
            }]
        }
    },
    search(lang) {
        lang = (lang ? lang : 'en').toLowerCase();
        const title = {
            fr: 'Trouver ma suite - MiHotel',
            en: 'Find my Suite - MiHotel'
        };
        const meta = {
            fr: 'Avec baignoire, cheminée ou avec vue : choisissez votre Suite préférée et concevez votre séjour idéal en plein cœur de Lyon. Collection de 40 Suites à Lyon.',
            en: 'With bathtub, fireplace or view: choose your favorite Suite and design your ideal stay in the heart of Lyon. Collection of 40 Suites in Lyon.'
        };
        return {
            title: title[lang] === undefined ? title.fr : title[lang],
            meta: [{
                vmid: 'description',
                name: 'description',
                content: meta[lang] === undefined ? meta.fr : meta[lang]
            }]
        }
    }
}



// WEBPACK FOOTER //
// ./src/helpers/meta.helper.js